<fd-panel
  fdCompact
  [(expanded)]="expanded"
  [fixed]="fixed"
  [expandAriaLabel]="expanded ? 'Collapse' : 'Expand'"
>
  <div
    class="wrapper"
    [class.no-panel-header]="!text || text.trim().length === 0"
  >
    <h3 fd-panel-title class="section-title" [title]="tooltip || ''">
      {{ text }}
    </h3>
    @if (required) {
      <span class="required-field">*</span>
    }
    @if (description) {
      <span>
        <app-help-popover
          [body]="description"
          [headerTitle]="text"
          [width]="width"
          [placement]="'bottom'"
        ></app-help-popover>
      </span>
    }
  </div>
  <div
    fd-panel-content
    ariaLabel="Panel Content"
    class="content-padding"
    id="panel-content"
  >
    @if (!enabled) {
      <div class="overlay" [title]="overlayTooltip"></div>
    }
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </div>
</fd-panel>
